module.exports = __webpack_public_path__ + "static/media/bus-blue.a7de9b06.svg";